(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-3d-zensea"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var stage = document.querySelector('.v3d__stage');
    if (!stage) return;
    function loadViewer() {
      if (!window.customElements || customElements.get('model-viewer')) return;
      if (document.querySelector('script[data-v3d-lib]')) return;
      var s = document.createElement('script');
      s.type = 'module';
      s.setAttribute('data-v3d-lib', '');
      s.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/4.0.0/model-viewer.min.js';
      document.head.appendChild(s);
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) { loadViewer(); io.disconnect(); }
      }, { rootMargin: '600px' });
      io.observe(stage);
    } else {
      loadViewer();
    }
  })();

  (function () {
    var canHover = window.matchMedia('(hover: hover)').matches;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!canHover || reduce) return;

    function bind(el, max) {
      var frame = null;
      el.addEventListener('pointermove', function (e) {
        if (frame) return;
        frame = requestAnimationFrame(function () {
          frame = null;
          var r = el.getBoundingClientRect();
          var px = (e.clientX - r.left) / r.width - 0.5;
          var py = (e.clientY - r.top) / r.height - 0.5;
          el.style.transform =
            'rotateY(' + (px * max).toFixed(2) + 'deg) rotateX(' + (-py * max).toFixed(2) + 'deg) translateZ(0)';
        });
      });
      el.addEventListener('pointerleave', function () {
        el.style.transform = '';
      });
    }

    document.querySelectorAll('[data-tilt]').forEach(function (el) { bind(el, 9); });
    document.querySelectorAll('[data-tilt-soft]').forEach(function (el) { bind(el, 3); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text-premium"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Apparition au défilement */
    var sections = document.querySelectorAll('.itp2--reveal');
    if (sections.length && 'IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
      sections.forEach(function (el) { io.observe(el); });
    } else {
      sections.forEach(function (el) { el.classList.add('is-in'); });
    }

    /* Léger basculement du cadre au survol, souris uniquement */
    if (!window.matchMedia('(hover: hover)').matches || reduce) return;
    document.querySelectorAll('[data-itp-tilt]').forEach(function (el) {
      var frame = el.querySelector('.itp2__frame');
      if (!frame) return;
      var raf = null;
      el.addEventListener('pointermove', function (ev) {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var r = el.getBoundingClientRect();
          var px = (ev.clientX - r.left) / r.width - 0.5;
          var py = (ev.clientY - r.top) / r.height - 0.5;
          frame.style.transform =
            'rotateY(' + (px * 5).toFixed(2) + 'deg) rotateX(' + (-py * 5).toFixed(2) + 'deg)';
        });
      });
      el.addEventListener('pointerleave', function () { frame.style.transform = ''; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zensea-hero-3d"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var stages = document.querySelectorAll('.vh3__stage');
    if (!stages.length) return;
    function loadViewer() {
      if (!window.customElements || customElements.get('model-viewer')) return;
      if (document.querySelector('script[data-v3d-lib]')) return;
      var s = document.createElement('script');
      s.type = 'module';
      s.setAttribute('data-v3d-lib', '');
      s.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/4.0.0/model-viewer.min.js';
      document.head.appendChild(s);
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) { loadViewer(); io.disconnect(); }
      }, { rootMargin: '600px' });
      stages.forEach(function (st) { io.observe(st); });
    } else {
      loadViewer();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zensea-scroll-3d"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var scenes = document.querySelectorAll('.vs3');
    if (!scenes.length) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    function loadViewer() {
      if (!window.customElements || customElements.get('model-viewer')) return;
      if (document.querySelector('script[data-v3d-lib]')) return;
      var s = document.createElement('script');
      s.type = 'module';
      s.setAttribute('data-v3d-lib', '');
      s.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/4.0.0/model-viewer.min.js';
      document.head.appendChild(s);
    }

    function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
    /* Adoucit les extrémités : la lumière ne monte pas linéairement. */
    function ease(t) { return t < .5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }

    function setup(sec) {
      if (sec.hasAttribute('data-vs3-ready')) return;
      sec.setAttribute('data-vs3-ready', '1');

      var scroller = sec.querySelector('[data-vs3-scroller]');
      var mv = sec.querySelector('[data-vs3-mv]');
      var halo = sec.querySelector('[data-vs3-halo]');
      var pool = sec.querySelector('[data-vs3-pool]');
      var beam = sec.querySelector('.vs3__beam');
      var bar = sec.querySelector('[data-vs3-bar]');
      var steps = sec.querySelectorAll('[data-vs3-step]');
      if (!scroller) return;

      /* Mouvement réduit : on pose la scène allumée, une bonne fois. */
      if (reduce.matches) {
        if (mv) { mv.exposure = 1.35; mv.cameraOrbit = '12deg 80deg 0.54m'; }
        if (bar) bar.style.transform = 'scaleX(1)';
        for (var i = 0; i < steps.length; i++) steps[i].classList.add('is-on');
        return;
      }

      var live = false;
      var raf = 0;
      var current = -1;

      function draw() {
        raf = 0;
        var r = scroller.getBoundingClientRect();
        var span = r.height - window.innerHeight;
        if (span <= 0) span = 1;
        var p = clamp(-r.top / span, 0, 1);
        var e = ease(p);

        if (mv && mv.cameraOrbit !== undefined) {
          var theta = (-26 + p * 52).toFixed(1);
          var radius = (0.62 - e * 0.13).toFixed(3);
          mv.cameraOrbit = theta + 'deg ' + (84 - e * 6).toFixed(1) + 'deg ' + radius + 'm';
          mv.exposure = (0.45 + e * 1.15).toFixed(3);
        }
        if (halo) {
          halo.style.opacity = (e * 0.95).toFixed(3);
          halo.style.transform = 'translate(-50%,-50%) scale(' + (0.7 + e * 0.42).toFixed(3) + ')';
        }
        if (pool) pool.style.opacity = (e * 0.8).toFixed(3);
        if (beam) beam.style.opacity = (e * 0.62).toFixed(3);
        if (bar) bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';

        if (steps.length) {
          var idx = clamp(Math.floor(p * steps.length * 0.999), 0, steps.length - 1);
          if (idx !== current) {
            current = idx;
            for (var i = 0; i < steps.length; i++) steps[i].classList.toggle('is-on', i === idx);
          }
        }
      }

      function tick() { if (!raf) raf = window.requestAnimationFrame(draw); }

      var io = new IntersectionObserver(function (entries) {
        live = entries[0].isIntersecting;
        if (live) { loadViewer(); tick(); }
      }, { rootMargin: '400px 0px 400px 0px' });
      io.observe(scroller);

      window.addEventListener('scroll', function () { if (live) tick(); }, { passive: true });
      window.addEventListener('resize', function () { if (live) tick(); }, { passive: true });
      if (mv) mv.addEventListener('load', tick);
      tick();
    }

    for (var i = 0; i < scenes.length; i++) setup(scenes[i]);

    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target ? e.target.querySelector('.vs3') : null;
      if (s) setup(s);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
